export const sessionStartTime = (session) => new Date(`${session['date']} ${session['time']}`);